var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.005 13a2 2 0 112 2 2 2 0 01-2-2zm-5 0a2 2 0 112 2 2 2 0 01-2.002-2zm-5 0a2 2 0 112 2A2 2 0 010 13zm10-5a2 2 0 112 2 2 2 0 01-2-2zm-5 0a2 2 0 112 2 2 2 0 01-2.002-2zm-5 0a2 2 0 112 2A2 2 0 010 8zm5-5a2 2 0 112 2 2 2 0 01-2.002-2zm-5 0a2 2 0 112 2A2 2 0 010 3zm11-1a2 2 0 112 2 2 2 0 01-2.001-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.4f904952.svg";
export { ForwardRef as ReactComponent };